import {INotificationDto} from '../../interfaces/dtos';
import {IState} from './Types';

/**
 *
 */
export const parser = {
  balanceList: (state: IState, payload: any): IState => {
    return {
      ...state,
      balances: payload ?? [],
    } as IState;
  },
  history: (state: IState, payload: any): IState => {
    return {
      ...state,
      history: payload ?? [],
    } as IState;
  },
  balanceSheet: (state: IState, payload: any): IState => {
    return {
      ...state,
      balanceSheet: payload,
    } as IState;
  },
  balanceSheetSalesman: (state: IState, payload: any): IState => {
    return {
      ...state,
      balanceSheetSalesman: payload,
    } as IState;
  },
  notificatioList: (state: IState, payload: any): IState => {
    return {
      ...state,
      notifications: payload ?? [],
    } as IState;
  },
  documentList: (state: IState, payload: any): IState => {
    return {
      ...state,
      documents: payload ?? [],
    } as IState;
  },
  debtorList: (state: IState, payload: any): IState => {
    return {
      ...state,
      debtors: payload ?? [],
    } as IState;
  },
  receivableList: (state: IState, payload: any): IState => {
    return {
      ...state,
      receivables: payload ?? [],
    } as IState;
  },
  semaphoreItems: (state: IState, payload: any): IState => {
    return {
      ...state,
      semaphoreItems: payload ?? [],
    } as IState;
  },
  tyc: (state: IState, payload: any) => {
    return {
      ...state,
      tyc: payload ?? '',
    } as IState;
  },
  isOutdated: (state: IState, payload: any): IState => {
    const {isOutdated} = payload;
    return {
      ...state,
      isOutdated,
    } as IState;
  },
  markNotificationsRead: (state: IState): IState => {
    if (state.notifications) {
      const list: INotificationDto[] | null = state.notifications.map(item => {
        item.unread = false;
        return item;
      });
      if (list) {
        state.notifications = [...list];
      }
    }
    return {
      ...state,
    } as IState;
  },
  addNotification: (state: IState, payload: any): IState => {
    if (state.notifications) {
      const {title, body} = payload;
      state.notifications = [
        {
          id: new Date().toLocaleDateString(),
          title,
          body,
          unread: true,
        },
        ...state.notifications,
      ];
    }
    return {
      ...state,
    } as IState;
  },
  setGoToMessage: (state: IState, payload: any): IState => {
    const {goToMessages} = payload;
    return {
      ...state,
      goToMessages,
    } as IState;
  },
  salesmanClientList: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanClients: payload ?? [],
    } as IState;
  },
  salesmanProductList: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanProductList: payload ?? [],
    } as IState;
  },
  setNewSalesmanClientRequest: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanNewClientRequest: payload ?? [],
    } as IState;
  },
  setSalesmanProductToAdd: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanProductToAdd: payload,
    } as IState;
  },
  updateSalesmanNewOrder: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanNewOrder: payload,
    } as IState;
  },
  updateCandidateToShoppingCart: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanOrderItemCandidate: payload,
    } as IState;
  },
  setSalesmanClient: (state: IState, payload: any): IState => {
    return {
      ...state,
      salesmanClient: payload,
    } as IState;
  },
  sendSalesmanNewOrder: (state: IState): IState => {
    return {
      ...state,
      salesmanNewOrder: null,
      salesmanProductToAdd: null,
      salesmanOrderItemCandidate: null,
    } as IState;
  },
  setState: (field: string, state: IState, payload: any): IState => {
    const newState = {
      ...state,
    } as IState;
    (newState as any)[field] = payload;
    return newState;
  },
};
